import { skipToken } from '@reduxjs/toolkit/query/react'
import { useFetchInfluencerAudienceAnalysisQuery } from '@/api/influencer-api'
import { useFetchUserStatusQuery } from '@/api/user-api'
import { useFetchKolAudienceAnalysisQuery } from '@/api/workspace-api/kol-api'
import { mockAudienceData } from '@/constants/kol-detail/mock-data'
import { usePermissions } from '@/hooks/use-permissions'
import { Audience } from '@/store/kol-detail'
import { PlatformCode } from '@/utils/convert-platform'

type UseAudienceAnalyze = (params: {
  kolId?: string
  kolDcIdHashed?: string
  platform: PlatformCode
  isLocked: boolean
  isFetchingKolInfo: boolean
}) => {
  audienceAnalyze?: Audience
  isFetching: boolean
}

const useAudienceAnalyze: UseAudienceAnalyze = ({
  kolId,
  kolDcIdHashed,
  platform,
  isLocked,
  isFetchingKolInfo,
}) => {
  const { withKolPermission } = usePermissions()

  const { data: userStatus, isFetching: isFetchingUserStatus } =
    useFetchUserStatusQuery(withKolPermission ? skipToken : undefined)

  const {
    data: audienceAnalyzeByAd,
    isFetching: isFetchingAudienceAnalyzeByAd,
  } = useFetchKolAudienceAnalysisQuery(
    !withKolPermission && userStatus?.currentWorkspaceId && kolId && !isLocked
      ? {
          workspaceId: userStatus.currentWorkspaceId,
          radar_uuid: kolId,
          dc_id_hashed: kolDcIdHashed,
        }
      : skipToken,
  )

  const {
    data: audienceAnalyzeByKol,
    isFetching: isFetchingAudienceAnalyzeByKol,
  } = useFetchInfluencerAudienceAnalysisQuery(
    withKolPermission && kolId ? kolId : skipToken,
  )

  const apiData = audienceAnalyzeByAd ?? audienceAnalyzeByKol
  const audienceAnalyze = isLocked ? mockAudienceData : apiData?.[platform]
  const isFetching =
    isFetchingUserStatus ||
    isFetchingKolInfo ||
    isFetchingAudienceAnalyzeByAd ||
    isFetchingAudienceAnalyzeByKol

  return { audienceAnalyze, isFetching }
}

export default useAudienceAnalyze
